import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.AccountBalance1,
  LocationVarKey.AccountBalance2,
  LocationVarKey.AccountBalance3,
  {
    key: LocationVarKey.AfterNavigateAccountLoginAccountBalance,
    hideIf: IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")
  },
  {
    key: LocationVarKey.AfterNavigateAccountLoginAccountBalance1,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginAccountBalance, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  },
  {
    key: LocationVarKey.AfterNavigateAccountLoginAccountBalance2,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginAccountBalance, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  },
  {
    key: LocationVarKey.FMSAccountBalanceChannel,
    hideIf: IS_NOT_EQUAL(LocationVarKey.HasAccountBalanceIntegration, "1")
  },
  {
    key: LocationVarKey.FMSAccountBalanceSMSMessage,
    hideIf: IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasAccountBalanceIntegration, "1"), IS_EQUAL(LocationVarKey.FMSAccountBalanceChannel, "Email")])
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        Account Balance
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AccountBalance1} />
      <TextAreaRow {...page} marginTop label=" Message 2" keyName={LocationVarKey.AccountBalance2} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 3 (Optional)"
        keyName={LocationVarKey.AccountBalance3}
        enableSwitchVar={LocationVarKey.AccountBalance3Enabled}
      />

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.AfterNavigateAccountLoginAccountBalance}
          label="Ask if they want to be navigated to your Account Login URL"
        />
        <Section
          {...page}
          hideIf={IF_ANY([
            IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginAccountBalance, "1"),
            IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
          ])}
        >
          <SectionHeader
            {...page}
            subheading="After navigating the customer to a new page, the chat will open and respond based on the information below."
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginAccountBalance, "1")}
          >
            {" "}
            After Navigate{" "}
          </SectionHeader>
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginAccountBalance, "1")}
            marginTop
            label=" Message 1"
            keyName={LocationVarKey.AfterNavigateAccountLoginAccountBalance1}
          />
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginAccountBalance, "1")}
            marginTop
            label=" Message 2 (Optional)"
            keyName={LocationVarKey.AfterNavigateAccountLoginAccountBalance2}
            enableSwitchVar={LocationVarKey.AfterNavigateAccountLoginAccountBalance2Enabled}
          />
        </Section>
      </Section>

      <SectionHeader {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasAccountBalanceIntegration, "1")}>
        {" "}
        Delivery Settings
      </SectionHeader>
      <DropdownRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasAccountBalanceIntegration, "1")}
        marginTop
        label=" Send Account Balance to Channel"
        keyName={LocationVarKey.FMSAccountBalanceChannel}
        options={[
          {
            label: "SMS",
            value: "SMS"
          },
          {
            label: "Email",
            value: "Email"
          },
          {
            label: "SMS and Email",
            value: "Both"
          }
        ]}
      />
      <TextAreaRow
        {...page}
        hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasAccountBalanceIntegration, "1"), IS_EQUAL(LocationVarKey.FMSAccountBalanceChannel, "Email")])}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.FMSAccountBalanceSMSMessage}
      />
    </>
  );
}
